export default "__VITE_ASSET__adb7f4b4__"